import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Validate deployment name is provided
  if (!properties.deploymentName || properties.deploymentName.trim() === '') {
    errors.push({
      key: 'deploymentName',
      message: 'Deployment name is required',
    });
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
